export function initFooter(d) {
    const footer = d.querySelector('footer');
    if (!footer) return; // Salir si no hay footer

    // Mover el footer-rrss al último li del menu-footer-container
    moveFooterRrssToLastMenuItem(footer);

    const targetSection = footer.previousElementSibling;
    let finalBgColor = null; // Puede ser una clase (string) o un color CSS (string)

    // Comprobar si el hermano anterior existe y es una .dot_section
    if (targetSection && targetSection.classList.contains('dot_section')) {
        // 1. Comprobar CSS background en la sección misma
        let computedBg = window.getComputedStyle(targetSection).backgroundColor;
        if (computedBg && computedBg !== 'rgba(0, 0, 0, 0)' && computedBg !== 'transparent') {
            finalBgColor = computedBg;
        }

        // 2. Si no hay CSS, buscar clase bg-* en la sección
        if (!finalBgColor) {
            for (const cls of targetSection.classList) {
                if (cls.startsWith('bg-')) {
                    finalBgColor = cls;
                    break;
                }
            }
        }

        // 3. Si no hay color aún, buscar en los hijos directos
        if (!finalBgColor) {
            for (const child of targetSection.children) {
                // 3a. Comprobar CSS background en el hijo
                computedBg = window.getComputedStyle(child).backgroundColor;
                if (computedBg && computedBg !== 'rgba(0, 0, 0, 0)' && computedBg !== 'transparent') {
                    finalBgColor = computedBg;
                    break; // Encontramos color CSS en un hijo
                }

                // 3b. Si no hay CSS en el hijo, buscar clase bg-* en el hijo
                for (const cls of child.classList) {
                    if (cls.startsWith('bg-')) {
                        finalBgColor = cls;
                        break; // Encontramos clase en un hijo
                    }
                }
                if (finalBgColor) break; // Salir del bucle de hijos si encontramos clase
            }
        }
    }

    // Aplicar el color encontrado al footer (si se encontró alguno)
    if (finalBgColor) {
        // Limpiar clases bg-* existentes y el estilo inline del footer
        const existingBgClasses = [...footer.classList].filter(cls => cls.startsWith('bg-'));
        footer.classList.remove(...existingBgClasses);
        footer.style.backgroundColor = ''; // Limpiar estilo inline

        // Aplicar el color encontrado
        if (finalBgColor.startsWith('bg-')) {
            // Es una clase de Tailwind
            footer.classList.add(finalBgColor);
        } else {
            // Es un color CSS
            footer.style.backgroundColor = finalBgColor;
        }
    } else {
         // Opcional: Limpiar el footer si no se encontró color en la sección anterior
         const existingBgClasses = [...footer.classList].filter(cls => cls.startsWith('bg-'));
         footer.classList.remove(...existingBgClasses);
         footer.style.backgroundColor = '';
    }

    // Comprobar si hay sub-menus en .footer-menu
    const footerMenuElem = footer.querySelector('.footer-menu');
    if (footerMenuElem) {
        // Buscar todos los sub-menus dentro de .footer-menu
        const subMenus = footerMenuElem.querySelectorAll('.sub-menu');
        subMenus.forEach(subMenu => {
            // Solo si hay más de 6 elementos hijos directos (li)
            // Añadimos una clase personalizada a los li con submenús
            
            const items = Array.from(subMenu.children).filter(child => child.tagName === 'LI');
            if (items.length > 6) {
                const parentLi = subMenu.closest('li.menu-item-has-children');
                if (parentLi) {
                    parentLi.classList.add('has-2cols-submenu');
                }
                // Crear dos divs para las columnas
                const col1 = document.createElement('div');
                const col2 = document.createElement('div');
                col1.className = 'sub-menu-col';
                col2.className = 'sub-menu-col';

                // Dividir los elementos en dos columnas
                const mitad = Math.ceil(items.length / 2);
                items.forEach((li, idx) => {
                    if (idx < mitad) {
                        col1.appendChild(li);
                    } else {
                        col2.appendChild(li);
                    }
                });

                // Limpiar el sub-menu y añadir las dos columnas
                subMenu.innerHTML = '';
                subMenu.appendChild(col1);
                subMenu.appendChild(col2);

                // Opcional: añadir clase para grid/columnas si usas Tailwind/CSS
                subMenu.classList.add('sub-menu-2cols');
            }
        });
    }
}

/**
 * Mueve el elemento .footer-rrss al último li del menu-footer-container dentro de su sub-menu
 */
function moveFooterRrssToLastMenuItem(footer) {

    // Buscar el elemento .footer-rrss dentro de .footer-menu
    const footerMenu = footer.querySelector('.footer-menu');
    if (!footerMenu) return;

    const footerRrss = footerMenu.querySelector('.footer-rrss');
    if (!footerRrss) return;

    // Buscar el menu-footer-container
    const menuFooterContainer = footerMenu.querySelector('.menu-footer-container');
    if (!menuFooterContainer) return;

    // Buscar el ul principal dentro del menu-footer-container
    const mainUl = menuFooterContainer.querySelector('ul');
    if (!mainUl) return;

    // Obtener todos los li del ul principal
    const menuItems = mainUl.querySelectorAll('li');
    if (menuItems.length === 0) return;

    // Obtener el último li
    const lastMenuItem = menuItems[menuItems.length - 1];

    // Buscar el sub-menu dentro del último li
    let subMenu = lastMenuItem.querySelector('.sub-menu');
    
    // Si no existe sub-menu, crearlo
    if (!subMenu) {
        subMenu = document.createElement('ul');
        subMenu.className = 'sub-menu';
        lastMenuItem.appendChild(subMenu);
    }

    // Crear un nuevo li para el footer-rrss
    const newLi = document.createElement('li');
    
    // Mantener la clase footer-rrss
    newLi.className = 'footer-rrss';
    
    // Mover el contenido del footer-rrss al nuevo li
    while (footerRrss.firstChild) {
        newLi.appendChild(footerRrss.firstChild);
    }
    
    // Agregar el nuevo li al final del sub-menu
    subMenu.appendChild(newLi);
    
    // Remover el contenedor .footer-rrss original
    footerRrss.remove();
}

